import { motion } from "framer-motion";

import logo from "../../assets/ZUIC-logo.png";

import RoundedButton from "../../components/ui/RoundedButton";

import ResearchCTA from "../../components/ui/ResearchCTA";

import JournalCarousel2 from "../../components/home/Research/JournalCarousel2";

import FocusArea3 from "../../components/home/Research/FocusArea3";

import ZUMSAdmin from "../../components/CenterOfExcellence/ZUICAdmin";
import useAxiosPublic from "../../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../../components/Layout/LoadingPage";
import { IMAGE_URL } from "../../constants";
import ProjectCarousel from "../../components/CenterOfExcellence/ProjectCarousel";
import WhatWeOffer from "../../components/WhatWeOffer";
const ResearchPage2 = () => {
  // const missionRef = useRef(null);
  // const visionRef = useRef(null);

  // const isMissionInView = useInView(missionRef, {
  //   once: false,
  //   margin: "-10%",
  // });
  // const isVisionInView = useInView(visionRef, { once: false, margin: "-10%" });

  const axiosPublic = useAxiosPublic();

  const {
    data: zuicData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["zuicApi"],
    queryFn: async () => {
      const res = await axiosPublic.get("/centers/zuics");
      return res?.data?.data;
    },
  });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }
  console.log(zuicData, "zuic data");

  return (
    <div className="min-h-screen">
      {/* Banner Section */}
      <div className="relative w-full h-[80vh] overflow-hidden">
        {/* Background Video */}
        <video
          className="absolute inset-0 object-cover w-full h-full"
          src={zuicData?.hero?.media_url}
          autoPlay
          loop
          muted
        ></video>

        {/* Overlay */}
        <div className="absolute bottom-0 z-20 flex flex-col items-center justify-center w-full h-full px-8 pb-10 bg-black bg-opacity-50 lg:items-start lg:justify-end"></div>
        <div className="absolute bottom-0 z-20 h-44 flex flex-col items-center justify-center w-full px-8 pb-10 bg-gradient-to-t from-[#F9FAFB] via-[#F9FAFB]/50 to-transparent lg:items-start lg:justify-end"></div>
        <div className="absolute z-30 flex flex-col items-center justify-center w-full h-full transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
          <motion.h1
            initial={{ y: "400px" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, delay: 0.5, ease: "linear" }}
            className="mt-2 text-3xl font-bold text-white font-domine md:text-4xl lg:text-7xl"
          >
            {zuicData?.hero?.title}
          </motion.h1>
        </div>

        {/* Logo */}
        <div className="absolute z-50 flex items-center justify-center w-full bottom-1/2 lg:bottom-0">
          <img className="w-48 md:w-72" src={logo} alt="Logo" />
        </div>
      </div>

      {/* Content Section */}
      <div className="container px-4 py-12 mx-auto sm:px-6 lg:px-8">
        <p className="text-2xl text-center text-gray-800">
          {zuicData?.zuic?.description}
        </p>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {/* Mission Section */}
          <div className="relative min-h-[60vh] mt-12 flex justify-start items-center">
            <div
              className="absolute inset-0 rounded-xl"
              style={{
                backgroundImage: `url(${IMAGE_URL}/${zuicData?.zuic?.ambient?.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "16px",
              }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50 rounded-xl"></div>
            </div>
            <motion.div
              // ref={missionRef}
              // initial={{ x: "-80%" }}
              // animate={isMissionInView ? { x: "0%" } : {}}
              // transition={{ duration: 1, ease: "easeIn" }}
              id="mission"
              style={{
                clipPath: "polygon(0 0, 30% 0, 100% 100%, 0% 100%)",
                borderRadius: "10px",
              }}
              className="relative flex justify-start items-center z-10 min-h-[60vh] p-4 lg:p-10 h-full w-[100vw] lg:max-w-[64vw] text-black bg-white rounded-2xl"
            >
              <div className="max-w-[50vw] lg:max-w-xs">
                <h1 className="text-xl font-semibold lg:text-3xl">
                  {zuicData?.zuic?.ambient?.title}
                </h1>
                <p className="mt-2 text-sm md:text-base">
                  {zuicData?.zuic?.ambient?.description}
                </p>
                <RoundedButton
                  className={`mt-2`}
                  href={zuicData?.zuic?.ambient?.link}
                  spanClassName={`text-primary`}
                >
                  Learn More
                </RoundedButton>
              </div>
            </motion.div>
          </div>

          {/* Vision Section */}
          <div className="relative min-h-[60vh] mt-12 flex justify-end items-center">
            <div
              className="absolute inset-0 rounded-xl"
              style={{
                backgroundImage: `url(${IMAGE_URL}/${zuicData?.zuic?.commitment?.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "10px", // Add rounded corners for the image section
              }}
            >
              <div className="absolute inset-0 bg-black bg-opacity-50 rounded-2xl"></div>
            </div>
            <motion.div
              // ref={visionRef}
              // initial={{ x: "80%" }}
              // animate={isVisionInView ? { x: "0%" } : {}}
              // transition={{ duration: 1, ease: "easeIn" }}
              // id="vision"
              style={{
                clipPath: "polygon(70% 0, 100% 0, 100% 100%, 0% 100%)",
                borderRadius: "10px",
              }}
              className="relative flex justify-start items-center z-10 min-h-[60vh] p-4 lg:p-10 h-full w-[100vw] lg:w-[70vw] text-black bg-white rounded-xl"
            >
              <div className="max-w-[100vw] absolute right-0 p-4 lg:p-10 lg:max-w-xl">
                <h1 className="text-xl font-semibold lg:text-3xl text-end">
                  {zuicData?.zuic?.commitment?.title}
                </h1>
                <p className="mt-2 text-sm max-w-[50vw] md:max-w-sm lg:max-w-xs text-end md:text-base">
                  {zuicData?.zuic?.commitment?.description}
                </p>
                <div className="flex justify-end ">
                  <RoundedButton
                    href={zuicData?.zuic?.commitment?.link}
                    className={`mt-2`}
                    spanClassName={`text-primary`}
                  >
                    Learn More
                  </RoundedButton>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      {/* <JournalCarousel /> */}
      <JournalCarousel2 data={zuicData?.zuic?.Journals} />
      <div className="container px-4 py-12 mx-auto sm:px-6 lg:px-8">
        <div>
          {/* <div className="w-full">
            <h2 className="mb-4 text-4xl font-bold text-center font-domine">
              Focus Area
            </h2>
            <div className="w-16 h-1 mx-auto my-4 bg-primary"></div>
          </div> */}
          {/* <FocusArea /> */}
          {/* <FocusCard /> */}
          {/* <div className="w-full">
            <h2 className="mb-4 text-4xl font-bold text-center font-domine">
              Focus Area
            </h2>
            <div className="w-16 h-1 mx-auto my-4 bg-primary"></div>
          </div> */}
          {/* <FocusArea2 /> */}
          <div className="w-full mt-16">
            <h2 className="mb-4 text-4xl font-bold text-center font-domine">
              Focus Area
            </h2>
            <div className="w-16 h-1 mx-auto my-4 bg-primary"></div>
          </div>
          <FocusArea3 data={zuicData?.zuic?.focus_areas} />
        </div>
        <div className="pb-14">
          <ProjectCarousel
            data={zuicData?.zuic?.team_projects}
            title={"Projects"}
          />
        </div>
        <ZUMSAdmin title={"Leader"} data={zuicData?.zuic?.team_members} />
        <ZUMSAdmin title={"Member"} data={zuicData?.zuic?.team_members} />

        {/* <div className="w-full mt-12">
          <h2 className="mb-4 text-4xl font-bold text-center font-domine">
            What We Offer
          </h2>
          <div className="w-16 h-1 mx-auto my-4 bg-primary"></div>
        </div> */}

        <WhatWeOffer what_we_offer={zuicData?.zuic?.what_we_offer} />
      </div>

      <div className="container px-4 py-12 mx-auto sm:px-6 lg:px-8">
        <ResearchCTA
          title={zuicData?.zuic?.contact?.title}
          description={zuicData?.zuic?.contact?.description}
          number={zuicData?.zuic?.contact?.phone}
          mail={zuicData?.zuic?.contact?.email}
        />
      </div>
      {/* <ResearchContactForm /> */}
    </div>
  );
};

export default ResearchPage2;
